WL.registerComponent('combiner', {
    leftHand: { type: WL.Type.Object },
    rightHand: { type: WL.Type.Object },

    wrappedTrain: { type: WL.Type.Object },

    paperXmas: { type: WL.Type.Material },
    paperRed: { type: WL.Type.Material },
    paperGreen: { type: WL.Type.Material },
    paperYellow: { type: WL.Type.Material },
    paperBlue: { type: WL.Type.Material },
    
    ribbonRed: { type: WL.Type.Material },
    ribbonGreen: { type: WL.Type.Material },
    ribbonYellow: { type: WL.Type.Material },
    ribbonBlue: { type: WL.Type.Material },
    ribbonPurple: { type: WL.Type.Material },

}, {
    start: function () {
        this.collision = this.leftHand.getComponent('collision');

        this.detailList = ['train', 'star', 'candy', 'chest', 'horse', 'xmas', 'red', 'yellow', 'blue', 'green', 'purple'];
        this.papers = {
            'xmas': this.paperXmas,
            'red': this.paperRed,
            'green': this.paperGreen,
            'yellow': this.paperYellow,
            'blue': this.paperBlue,
        }
        this.ribbons = {            
            'red': this.ribbonRed,
            'green': this.ribbonGreen,
            'yellow': this.ribbonYellow,
            'blue': this.ribbonBlue,
            'purple': this.ribbonPurple,
        }
    },

    update: function (dt) {
        let overlaps = this.collision.queryOverlaps();
        let rightHand = overlaps.find(o => o.object.name == 'Hand Right');      
        if(!rightHand && this.onlyOnce){
            this.onlyOnce = false;
        }  
        if (rightHand && window.SW.gameState._holding.length === 2 && !this.onlyOnce) {        
            
            this.onlyOnce = true;

            let object1 = window.SW.gameState._holding[0];
            let object2 = window.SW.gameState._holding[1];
            
            let replace, paper, paperSubtype, ribbon, ribbonSubtype;
            let paperWrap=false,ribbonWrap=false;
          
            if (object1.type === 'gift' && object2.type === 'paper') {
                replace = object1.grabber.children.find(c => c.name !== 'HandModel');
                paper = this.papers[object2.subtype];
                paperWrap = true;
                paperSubtype = object2.subtype;
            }
            if (object2.type === 'gift' && object1.type === 'paper') {
                replace = object2.grabber.children.find(c => c.name !== 'HandModel');
                paper = this.papers[object1.subtype];
                paperWrap = true;
                paperSubtype = object1.subtype;
            }
            if (object1.type === 'gift' && object2.type === 'ribbon') {
               
                replace = object1.grabber.children.find(c => c.name !== 'HandModel');
                ribbon = this.ribbons[object2.subtype];
                ribbonWrap = true;
                ribbonSubtype = object2.subtype;
            }            
            if (object2.type === 'gift' && object1.type === 'ribbon') {
                
                replace = object2.grabber.children.find(c => c.name !== 'HandModel');
                ribbon = this.ribbons[object1.subtype];
                ribbonSubtype = object1.subtype;
                ribbonWrap = true;
            }

            if (replace) {     
                //TODO: Clear hand with paper or ribbon                           
                if(paperWrap){
                    window.SW.instructions.play('paper');     
                    replace.getComponent('wrapper').wrap(paper, paperSubtype);
                }
                if(ribbonWrap){
                    window.SW.instructions.play('ribbon');     
                    replace.getComponent('wrapper').wrapRibbon(ribbon, ribbonSubtype);
                }                
                poof(this.leftHand.getTranslationWorld([]));
            }
            
            
        }
    },

});
